import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconCompanySvg } from "./IconCompanySvg.mjs";
const IconCompany = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconCompanySvg, ...svgProps }) });
export {
  IconCompany
};
